import styled from 'styled-components';

import { Heading } from '@notino/react-styleguide-v20';

export const StyledCartTitle = styled(Heading.H1)`
  text-align: center;
`;

export const StyledCartBody = styled.div`
  min-height: 20rem;
`;

export const StyledCartContent = styled.div``;
